var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVLightLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5516 0.667969L11.2899 18.2493H6.71093L0.449219 0.667969H4.86791L8.90883 13.7281H9.09199L13.1444 0.667969H17.5516Z",
    fill: "#154043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLightLogo);
export default __webpack_public_path__ + "static/media/v-light-logo.e996015516e915834f1e0422c6246b4e.svg";
export { ForwardRef as ReactComponent };